<template>
  <section>
    <div class="card" v-if="client">
      <div class="card-content pa-20">
        <div class="media">
          <div class="media-left">
            <figure class="image imagePanier">
              <img :src="getImg(logo.chemin)">
            </figure>
          </div>
          <div class="media-content">
            <p class="title is-4 has-text-grid-1 is-marginless">{{client.nomCommercial}}</p>
            <div  v-if="type === config.POINT_VENTE && client.tiersParent">
              <p class="has-text-grid-2 is-size-14px is-marginless">
                {{$t('detailClient.informations.enseigne')}}
                <span class="information">
                  {{client.tiersParent.nomCommercial}}</span>
              </p>
              <p class="has-text-grid-2 is-size-14px" v-if="client.tiersParent.tiersParent">
                {{$t('detailClient.informations.groupe')}}
                <span class="information">
                  {{client.tiersParent.tiersParent.nomCommercial}}
                </span>
              </p>
            </div>
            <p class="has-text-grid-2 is-size-14px" v-if="type === config.ENSEIGNE && client.tiersParent">
              {{$t('detailClient.informations.groupe')}}
              <span class="information">
                {{client.tiersParent.nomCommercial}}</span>
            </p>
          </div>
        </div>
        <div class="content">
          <div class="column columns is-multiline is-paddingless">
            <div class="column is-3">
              <p class="has-text-grid-1 is-size-7 has-text-weight-bold is-marginless">
                {{$t('detailClient.informations.adresse')}}</p>
              <p class="information">{{client.adrComplet}}</p>
            </div>
            <div class="column is-3">
              <p class="has-text-grid-1 is-size-7 has-text-weight-bold is-marginless">
                {{$t('detailClient.informations.marques')}}</p>
              <p class="information">{{marquesString}}</p>
            </div>
            <div class="column is-3">
              <p class="has-text-grid-1 is-size-7 has-text-weight-bold is-marginless">
                {{$t('detailClient.informations.secteurActivite')}}</p>
              <p class="information">{{secteurActivite}}</p>
            </div>
            <div class="column is-3">
              <p class="has-text-grid-1 is-size-7 has-text-weight-bold is-marginless">
                {{$t('detailClient.informations.email')}}</p>
              <p class="information">{{client.email}}</p>
            </div>
            <div class="column is-3">
              <p class="has-text-grid-1 is-size-7 has-text-weight-bold is-marginless">
                {{$t('detailClient.informations.telephone')}}</p>
              <p class="information">{{client.telephone}}</p>
            </div>
            <div class="column is-3">
              <p class="has-text-grid-1 is-size-7 has-text-weight-bold is-marginless">
                {{$t('detailClient.informations.societe')}}</p>
              <p class="information">{{ libellSociete }}</p>
            </div>
            <div class="column is-3">
              <p class="has-text-grid-1 is-size-7 has-text-weight-bold is-marginless">
                {{$t('detailClient.informations.applicationTva')}}</p>
              <p class="information">{{ libelleApplicationTva }}</p>
            </div>
            <div class="column is-3">
              <p class="has-text-grid-1 is-size-7 has-text-weight-bold is-marginless">
                {{$t('detailClient.informations.referenceHavas')}}</p>
              <p class="information">{{ client.referenceHavas }}</p>
            </div>
            <div class="column is-3">
              <p class="has-text-grid-1 is-size-7 has-text-weight-bold is-marginless">
                {{$t('detailClient.informations.siren')}}</p>
              <p class="information">{{ client.siren }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { getImg } from '@/services/general/general'
import * as config from '@/configuration/clientConf';
import LISTE_APPLICATION_TVA from '@/configuration/applicationTvaConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametrage');

export default {
  props: {
    client: Object,
    logo: Object,
  },
  data: () => ({
    config,
  }),
  computed: {
    ...Societe.mapGetters({
      societes: 'societes',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    type() {
      return this.$route.params.type;
    },
    libellSociete() {
      const result =  this.societes.find(s => s.id === this.client.societeId);
      return result ? result.libelle : '';
    },
    libelleApplicationTva() {
      const find = LISTE_APPLICATION_TVA.find(appTva => appTva.code === this.client.applicationTva);
      return find ? this.$t(find.libelle) : '';
    },
    secteurActivite() {
      const { secteurActiviteId } = this.client;
      const find = this.parametre(PARAMETRES_KEYS.secteurActivite)
        .find(s => s.id === secteurActiviteId);
      return find ? find.libelle : '';
    },
    marquesString() {
      return (this.client.tiersMarques || [])
        .filter(el => !!el.marque && !!el.marque.libelle)
        .map(el => el.marque.libelle)
        .join(', ');
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getImg(img) {
      return getImg(img);
    },
  },
  async mounted() {
    await this.loadParametres([PARAMETRES_KEYS.secteurActivite]);
  },
}
</script>
